export const JETLIFT_ENDPOINTS = {
  GET_OIL_API_CHANGE: '/Determine/JetLift/Calculation/GetOilAPIChange',
  GET_RESV_PRESR_CHANGE: '/Determine/JetLift/Calculation/GetResvPresrChange',
  GET_PROD_RATE_CHANGE: '/Determine/JetLift/Calculation/GetProdRateChange',
  GET_WATER_CUT_CHANGE: '/Determine/JetLift/Calculation/GetWaterCutChangeOilCt',
  GET_BUBBLE_POINT: '/Determine/JetLift/Calculation/GetBubblPnt',
  GET_GAS_CALC_DATA: '/Determine/JetLift/Calculation/GetGasCalcData',
  GET_WATER_CUT_CHANGE_COMBSPGR: '/Determine/JetLift/Calculation/GetWaterCtChangeCombSpGr',
  GET_LINER_OD_LIST: '/Determine/JetLift/Project/GetLinerODList',
  GET_LINER_ID: '/Determine/JetLift/Project/GetLinerID',
  GET_CASING_DRIFT_ID: '/Determine/JetLift/Project/GetCasingDriftID',
  GET_LINER_WEIGHT_LIST: '/Determine/JetLift/Project/GetLinerWeightList',
  GET_TUBING_WEIGHT_LIST: '/Determine/JetLift/Project/GetTubingWeightList',
  GET_TUBING_ID: '/Determine/JetLift/Project/GetTubingID',
  GET_SP_GR_OIL_CHANGE: '/Determine/JetLift/Project/GetSpGrOilChange',
  GET_FLOP_VALUE: "/Determine/JetLift/Calculation/GetFLOPValue",
  GET_STATIC_FLUID_CHANGE: "/Determine/JetLift/Calculation/GetStatFldChange",
  GET_FLUID_VISCOSITY_CHANGE: "/Determine/JetLift/Calculation/ReservoirFluidViscosity",
  GET_BUBBLE_POINT_PRESSURE: "/Determine/JetLift/Calculation/GetBubblePointPressure",
  GET_GAS_COMPRESS: "/Determine/JetLift/Calculation/getGasCompress",
  GET_INFLOW_CALCULATIONS: "/Determine/JetLift/Calculation/InflowCalculations",
  GET_WELL_INFLOW_LIST: "/Determine/JetLift/Calculation/wellInflowList",
  GET_DEPLETION_PERCENTAGE: "/Determine/JetLift/Calculation/GetDepletionPercentage",
  GET_DEPLETION_GRAPH_DATA: "/Determine/JetLift/Calculation/GetDepletionGraphData",
  GET_IPR_GRAPH_DATA: "/Determine/JetLift/Calculation/GetIPRGraphData",
  GET_FUTURE_BHP: "/Determine/JetLift/Calculation/GetFutureBHP",
  GET_CASING_OD: "/Determine/JetLift/Calculation/GetCasingOD",
  GET_CASING_WEIGHT_LIST: "/Determine/JetLift/Project/GetCasingWeightList",
  GET_CASING_ID: "/Determine/JetLift/Project/GetCasingID",
  GET_PROJECT_DETAILS: "/Determine/JetLift/Calculation/GetProjectDetails",
  GET_GAS_INTAKE_DATA: "/Determine/JetLift/Calculation/GetGasIntake",
  GET_FUTURE_PRODUCTION_RATE: "/Determine/JetLift/Project/GetFutureProductionRate",
  GET_DEPLETION_PRESSURE: "/Determine/JetLift/Calculation/GetDepletionPressure",
  SAVE_PROJECT: "/Determine/JetLift/Project/SaveProject",
  CREATE_NEW_CASE: "/Determine/JetLift/Project/createnewcase",
  DELETE_CASE: "/Determine/JetLift/Project/DeleteCase",
  COPY_PROJECT: "/Determine/JetLift/Project/_CopyProject1",
  GET_BASIC_SUMMARY: "/Determine/JetLift/Calculation/BasicCalculationSummary",
  GET_BASIC_SUMMARY_SCENARIOS: "/Determine/JetLift/Calculation/MatchProductionRate",
  GET_NOZZLE_THROAT_LIST: "/Determine/JetLift/Project/catalogNozzleThroat",
  GET_AREA: "/Determine/JetLift/Calculation/GetArea",
  SAVE_MAIN_REPORT_DATA: "/Determine/JetLift/Calculation/SaveMainReportData",
  GET_CASE_COMPARISON_DATA: "/Determine/JetLift/Project/GetcaseComparision",
  DOWNLOAD_JL_MAIN_REPORT: "/Determine/JetLift/Calculation/DownloadJLMainReport/",
} as const;